import LicenseContext from './license-context';
import useLicense from '../hooks/use-license';

export default function LicenseContextProvider({ children }) {
  const licenseData = useLicense();

  return (
    <LicenseContext.Provider value={licenseData}>
      {children}
    </LicenseContext.Provider>
  );
}